<template>
<div class="edu-records">
    <nav class="edu-record-breadcrumb" aria-label="页面位置"><router-link to="/home/index">首页</router-link><v-icon size="13">mdi-chevron-right</v-icon><span>教务中心</span><v-icon size="13">mdi-chevron-right</v-icon><span>课后点评</span></nav>
    <header class="edu-record-heading"><h1>课后点评</h1><p>回顾课堂表现与成长瞬间，查看点评内容及家长通知进度。</p></header>
    <section class="edu-record-filters" aria-label="点评筛选"><div class="edu-record-filter-title"><h2>筛选课后点评</h2><span>按学员、授课老师与点评时间查询</span></div>
      <form @submit.prevent="search"><div class="edu-record-fields"><v-text-field v-model="filters.student" label="学员姓名" aria-label="学员姓名" clearable dense outlined hide-details color="#d9363e" maxlength="60" />
        <v-select v-model="filters.classId" :items="classes" item-text="className" item-value="id" label="班级" aria-label="班级" clearable dense outlined hide-details color="#d9363e" />
        <v-select v-model="filters.teacherId" :items="teachers" item-text="trueName" item-value="id" label="授课老师" aria-label="授课老师" clearable dense outlined hide-details color="#d9363e" />
        <v-text-field v-model="filters.start" type="date" label="点评开始日期" aria-label="点评开始日期" clearable dense outlined hide-details color="#d9363e" />
        <v-text-field v-model="filters.end" type="date" label="点评结束日期" aria-label="点评结束日期" clearable dense outlined hide-details color="#d9363e" /></div>
      <div class="edu-record-filter-bottom"><span>查询当前校区的课后点评</span><div class="edu-record-filter-actions"><v-btn text class="edu-record-reset" @click="reset">重置</v-btn><v-btn depressed class="edu-record-query" type="submit" :loading="loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form>
    </section>
    <v-alert v-if="optionsError" type="warning" text dense>{{ optionsError }}<v-btn small text @click="loadOptions">重试</v-btn></v-alert>
    <v-alert v-if="error" type="error" text dense>{{ error }}<v-btn small text @click="load(page)">重新加载</v-btn></v-alert>
    <section class="edu-record-list" aria-label="课后点评列表"><div class="edu-record-toolbar"><h2>点评列表</h2><span class="edu-record-count">共 <strong>{{count}}</strong> 条</span><span class="edu-record-toolbar-note">课堂反馈与家长通知记录</span></div><v-data-table :headers="headers.filter(header => !['className','rateScore','imgList','sendTime'].includes(header.value))" :items="items" :loading="loading" item-key="id" disable-pagination hide-default-footer
        class="edu-record-table edu-record-table-review review-table" :mobile-breakpoint="0" loading-text="正在加载点评……" no-data-text="暂无课后点评">
        <template v-slot:item.studentName="{ item }"><strong class="edu-record-name">{{item.studentName || '—'}}</strong></template>
        <template v-slot:item.courseName="{ item }"><div>{{item.courseName || '—'}}</div><div class="edu-record-secondary">{{item.className || '—'}}</div></template>
        <template v-slot:item.classDate="{ item }">
          <div class="text-no-wrap">{{ item.classDate || '—' }}</div>
          <div class="grey--text text-no-wrap">{{ lessonTime(item) }}</div>
        </template>
        <template v-slot:item.content="{ item }">
          <div class="edu-review-feedback">
            <span v-if="item.rateScore > 0" class="edu-record-score"><v-icon size="16">mdi-star</v-icon>{{item.rateScore}} / 5</span>
            <div class="review-content">{{item.content || '暂无文字点评'}}</div>
            <div v-if="imageSources(item).length" class="d-flex align-center mt-2">
              <button v-for="(src,index) in imageSources(item).slice(0,3)" :key="index" type="button" class="mr-1 review-thumbnail" aria-label="查看点评图片" @click="preview=src"><v-img :src="thumbnailSource(src)" width="44" height="44" alt="点评图片" /></button>
              <span v-if="imageSources(item).length>3">+{{imageSources(item).length-3}}</span>
            </div>
          </div>
        </template>
        <template v-slot:item.createAt="{ item }"><span class="text-no-wrap">{{ item.createAt || '—' }}</span></template>
        <template v-slot:item.pushStatus="{ item }"><span class="edu-record-status" :class="{'edu-record-status-success':item.pushStatus==='sent','edu-record-status-info':item.pushStatus==='scheduled','edu-record-status-warning':['not_queued','unconfirmed'].includes(item.pushStatus)}">{{ pushLabel(item.pushStatus) }}</span><div class="edu-record-secondary">发送时间：{{item.sendTime || '—'}}</div></template>
        <template v-slot:item.action="{ item }"><div class="edu-record-actions">
          <v-btn small text color="#b94852" @click="selected = item">查看详情</v-btn>
          <v-btn v-if="canUpdate" small text color="#b94852" @click="openEdit(item)">修改</v-btn>
          <v-btn v-if="canDelete" small text color="error" @click="openDelete(item)">删除</v-btn>
        </div></template>
      </v-data-table>
      <div class="edu-record-pagination"><div class="edu-record-page-total"><span>共 {{count}} 条点评</span><v-select :value="size" :items="[10,20,50,100]" label="每页数量" aria-label="每页数量" outlined dense hide-details color="#d9363e" @change="changeSize" /></div><v-pagination v-if="count>0" :value="page" :length="Math.ceil(count/size)" :total-visible="5" @input="load" color="#d9363e" /></div>
    </section><v-dialog :value="!!selected" max-width="820" scrollable @input="closeDetails">
      <v-card v-if="selected" class="edu-record-dialog">
        <v-card-title>课后点评详情<v-spacer /><v-btn icon aria-label="关闭详情" @click="selected = null"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <v-row dense>
            <v-col cols="6">学员：{{ selected.studentName || '—' }}</v-col>
            <v-col cols="6">授课老师：{{ selected.teacherName || '—' }}</v-col>
            <v-col cols="6">课程：{{ selected.courseName || '—' }}</v-col>
            <v-col cols="6">班级：{{ selected.className || '—' }}</v-col>
            <v-col cols="12">上课时间：{{ selected.classDate || '—' }} {{ lessonTime(selected) }}</v-col>
            <v-col cols="12">点评时间：{{ selected.createAt || '—' }}</v-col>
            <v-col cols="12">推送状态：<v-chip small :color="pushColor(selected.pushStatus)">{{ pushLabel(selected.pushStatus) }}</v-chip></v-col>
            <v-col cols="12">预计发送时间：{{ selected.expectedSendTime || '—' }}</v-col>
            <v-col cols="12">发送时间：{{ selected.sendTime || '—' }}</v-col>
            <v-col cols="12"><v-alert type="info" text dense class="mb-0">{{ selected.pushMessage || '暂无通知记录，无法确认是否推送。' }}</v-alert></v-col>
            <v-col cols="12" class="d-flex align-center">课堂评分：<v-rating v-if="selected.rateScore > 0" :value="selected.rateScore" readonly dense color="amber" /><span v-else>—</span></v-col>
          </v-row>
          <div class="review-full-content mt-3">{{ selected.content || '暂无文字点评' }}</div>
          <div class="d-flex flex-wrap mt-4">
            <button v-for="(src, index) in imageSources(selected)" :key="index" class="mr-2 mb-2 review-thumbnail" type="button" aria-label="查看点评图片" @click="preview = src"><v-img :src="src" width="120" height="100" alt="点评图片" /></button>
          </div>
        </v-card-text>
        <v-card-actions><v-spacer /><v-btn text @click="selected = null">关闭</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :value="!!editing" max-width="760" scrollable persistent>
      <v-card v-if="editing" class="edu-record-dialog">
        <v-card-title>修改课后点评</v-card-title>
        <v-card-text>
          <p>学员：{{ editing.studentName || '—' }}　班级：{{ editing.className || '—' }}</p>
          <v-alert type="info" text dense>仅修改当前学员这一条点评。</v-alert>
          <v-alert v-if="mutationError" type="error" text dense>{{ mutationError }}</v-alert>
          <div class="d-flex align-center">课堂评分：<v-rating v-model="editing.rateScore" :readonly="saving" color="amber" /></div>
          <v-textarea v-model="editing.content" label="点评内容" outlined rows="4" counter="255" :disabled="saving" />
          <div class="d-flex flex-wrap">
            <div v-for="(src, index) in editing.imgList" :key="index" class="mr-3 mb-3">
              <v-img v-if="imageSources({ imgList: [src] }).length" :src="thumbnailSource(imageSources({ imgList: [src] })[0])" width="90" height="90" />
              <span v-else>无法预览的图片</span>
              <v-btn small text color="error" :disabled="saving || uploading" :aria-label="'移除图片' + (index + 1)" @click="editing.imgList.splice(index, 1)">移除</v-btn>
            </div>
          </div>
          <cut-image-upload v-if="editing.imgList.length < 6 && !saving" :key="editing.id" title="添加点评图片" :viewPrevImage="false" @success="imageUploaded" @uploading="uploading = $event" />
          <div class="grey--text">最多6张图片</div>
        </v-card-text>
        <v-card-actions><v-spacer /><v-btn text :disabled="saving || uploading" @click="editing = null">取消</v-btn><v-btn color="#d9363e" dark :loading="saving" :disabled="saving || uploading" @click="saveEdit">保存修改</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :value="!!deleting" max-width="540" persistent>
      <v-card v-if="deleting" class="edu-record-dialog">
        <v-card-title>删除课后点评</v-card-title>
        <v-card-text>
          确认删除“{{ deleting.studentName || '该学员' }}”这一条点评？其他学员的点评不受影响。
          <p class="mt-3">删除后该点评将从点评列表和学员动态中移除；该课次没有其他有效点评时，学员恢复待点评状态。</p>
          <v-alert v-if="mutationError" type="error" text dense>{{ mutationError }}</v-alert>
        </v-card-text>
        <v-card-actions><v-spacer /><v-btn text :disabled="saving" @click="deleting = null">取消</v-btn><v-btn color="error" :loading="saving" :disabled="saving" @click="confirmDelete">确认删除</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :value="!!preview" max-width="1000" @input="closePreview">
      <v-card class="edu-record-dialog"><v-card-title>点评图片<v-spacer /><v-btn icon aria-label="关闭图片" @click="preview = ''"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
        <v-img v-if="preview" :src="preview" contain max-height="75vh" alt="点评大图" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import utils from '../../../config/utils'
import global from '../../../config/global'
import CutImageUpload from '../../../components/cut_image_upload.vue'

const emptyFilters = () => ({ student: '', classId: '', teacherId: '', start: '', end: '' })
export default {
  name: 'after-class-review-list',
  components: { CutImageUpload },
  data() {
    return {
      filters: emptyFilters(), applied: emptyFilters(), classes: [], teachers: [],
      items: [], count: 0, page: 1, size: 20, loading: false, error: '', optionsError: '',
      requestId: 0, optionsRequestId: 0, selected: null, preview: '',
      canUpdate: false, canDelete: false, editing: null, deleting: null,
      saving: false, uploading: false, mutationError: '',
      breadcrumbs: [{ text: '首页', href: '/' }, { text: '教务中心', disabled: true }, { text: '课后点评', disabled: true }],
      headers: [
        { text: '学员', value: 'studentName' }, { text: '课程', value: 'courseName' },
        { text: '班级', value: 'className' }, { text: '授课老师', value: 'teacherName' },
        { text: '上课时间', value: 'classDate' }, { text: '评分', value: 'rateScore' },
        { text: '点评内容', value: 'content', width: 260 }, { text: '图片', value: 'imgList' },
        { text: '点评时间', value: 'createAt' }, { text: '推送状态', value: 'pushStatus' },
        { text: '发送时间', value: 'sendTime' }, { text: '操作', value: 'action', width: 230 }
      ].map(header => ({ ...header, sortable: false }))
    }
  },
  created() { this.loadOptions(); this.load(1) },
  beforeDestroy() { this.requestId++; this.optionsRequestId++ },
  methods: {
    pushLabel(state) { return { sent: '已推送（系统记录）', scheduled: '待定时发送', not_queued: '未入队', unconfirmed: '结果待确认' }[state] || '状态待核实' },
    pushColor(state) { return { sent: 'success', scheduled: 'info', not_queued: 'warning', unconfirmed: 'warning' }[state] || 'grey lighten-2' },
    async loadOptions() {
      const id = ++this.optionsRequestId
      const shopId = utils.getCurrentShopId()
      if (!shopId) return
      this.optionsError = ''
      try {
        const responses = await Promise.all([
          this.axios.get(`/edu/shop/class/list/${encodeURIComponent(shopId)}`),
          this.axios.get(`/edu/shop/teacher/list/${encodeURIComponent(shopId)}`)
        ])
        if (id !== this.optionsRequestId) return
        if (responses.some(response => response.data.code !== 200)) throw new Error('获取班级或老师筛选项失败')
        this.classes = responses[0].data.data || []
        this.teachers = responses[1].data.data || []
      } catch (error) {
        if (id === this.optionsRequestId) this.optionsError = '筛选选项加载失败，可重试或直接查询点评。'
      }
    },
    search() {
      if (this.filters.start && this.filters.end && this.filters.start > this.filters.end) {
        this.$noty.error('开始日期不能晚于结束日期'); return
      }
      this.applied = { ...this.filters }
      this.load(1)
    },
    reset() { this.filters = emptyFilters(); this.search() },
    changeSize(value) { this.size = value; this.load(1) },
    async load(page) {
      const id = ++this.requestId
      this.page = page
      this.loading = true
      this.error = ''
      this.items = []; this.count = 0
      this.canUpdate = false; this.canDelete = false
      try {
        const shopId = utils.getCurrentShopId()
        if (!shopId) throw new Error('请先选择校区')
        const params = { shopId }
        Object.entries(this.applied).forEach(([key, value]) => { if (value !== '' && value != null) params[key] = value })
        const response = await this.axios.get(`/edu/review/list/page/${page - 1}/size/${this.size}`, { params })
        if (id !== this.requestId) return
        if (response.data.code !== 200) throw new Error(response.data.message || '获取课后点评失败')
        const data = response.data.data || {}
        this.items = Array.isArray(data.list) ? data.list : []
        this.count = Number(data.count) || 0
        this.canUpdate = data.canUpdate === true; this.canDelete = data.canDelete === true
      } catch (error) {
        if (id === this.requestId) this.error = error.response ? '请求失败，请稍后重试' : (error.message || '获取课后点评失败')
      } finally {
        if (id === this.requestId) this.loading = false
      }
    },
    openEdit(item) {
      if (!this.canUpdate || this.saving) return
      this.mutationError = ''; this.uploading = false
      this.editing = { ...item, content: item.content || '', imgList: [...(item.imgList || [])], shopId: utils.getCurrentShopId() }
    },
    openDelete(item) {
      if (!this.canDelete || this.saving) return
      this.mutationError = ''
      this.deleting = { ...item, shopId: utils.getCurrentShopId() }
    },
    imageUploaded(result) {
      if (!this.editing || !result.key) return
      if (this.editing.imgList.length >= 6) { this.$noty.error('最多上传6张图片'); return }
      this.editing.imgList.push(result.key)
    },
    saveEdit() {
      const item = this.editing
      if (!item || this.saving || this.uploading) return
      if (!Number.isInteger(item.rateScore) || item.rateScore < 1 || item.rateScore > 5) { this.mutationError = '评分须为1至5分'; return }
      if (!(item.content || '').trim() && !item.imgList.length) { this.mutationError = '请填写点评内容或上传图片'; return }
      if ([...(item.content || '')].length > 255) { this.mutationError = '点评内容不能超过255字'; return }
      return this.mutate('update', item)
    },
    confirmDelete() { if (this.deleting && !this.saving) return this.mutate('delete', this.deleting) },
    async mutate(action, item) {
      this.saving = true; this.mutationError = ''
      try {
        if (item.shopId !== utils.getCurrentShopId()) throw new Error('当前校区已变更，请关闭弹窗后刷新列表')
        const body = { id: item.id, version: item.version }
        if (action === 'update') Object.assign(body, { rateScore: item.rateScore, content: item.content || '', imgList: item.imgList })
        const response = await this.axios.post(`/edu/review/${action}`, body, { params: { shopId: item.shopId } })
        if (response.data.code !== 200) throw new Error(response.data.message || '操作失败')
        this.editing = null; this.deleting = null; this.selected = null
        this.$noty.success(action === 'delete' ? '删除成功' : '修改成功')
        const page = action === 'delete' && this.items.length === 1 && this.page > 1 ? this.page - 1 : this.page
        await this.load(page)
      } catch (error) {
        this.mutationError = error.response ? '请求失败，请稍后重试' : (error.message || '操作失败，请稍后重试')
      } finally { this.saving = false }
    },
    lessonTime(item) { return item.timeFrom && item.timeTo ? `${item.timeFrom}–${item.timeTo}` : '' },
    imageSources(item) {
      return (Array.isArray(item.imgList) ? item.imgList : []).map(value => {
        if (typeof value !== 'string') return ''
        const image = value.trim()
        if (!image || /[\x00-\x1f]/.test(image)) return ''
        if (/^https?:\/\//i.test(image)) return image
        if (/^[a-z][a-z0-9+.-]*:/i.test(image) || image.startsWith('//') || image.includes('\\')) return ''
        return global.config.imgPre + image.replace(/^\/+/, '')
      }).filter(Boolean)
    },
    thumbnailSource(src) {
      const url = new URL(src)
      if (url.origin !== new URL(global.config.imgPre).origin) return src
      const params = url.search.slice(1).split('&').filter(param => param && !param.startsWith('imageView2/'))
      params.push('imageView2/1/w/100/h/100')
      url.search = params.join('&')
      return url.href
    },
    closeDetails(open) { if (!open) this.selected = null },
    closePreview(open) { if (!open) this.preview = '' }
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/styles/edu-records.scss";

.review-content { min-width:180px; max-width:300px; display:-webkit-box; -webkit-line-clamp:3; -webkit-box-orient:vertical; overflow:hidden; white-space:pre-wrap; overflow-wrap:anywhere; }
.review-full-content { white-space:pre-wrap; overflow-wrap:anywhere; line-height:1.8; padding:16px 18px; border:1px solid #edf0f4; border-radius:8px; background:#fafbfd; }
.review-thumbnail { border-radius:6px; overflow:hidden; border:1px solid #e6ebf1; flex-shrink:0; }.review-thumbnail:focus-visible { outline:2px solid #d9363e; outline-offset:2px; }

</style>
